import styled from "styled-components";

export const MarkerStyles: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

interface StopLabelProps {
  center?: boolean;
}

export const StopLabelStyled = styled.div<StopLabelProps>`
  font-family: "Readex Pro", sans-serif;
  line-height: 120%;
  color: #172a3f;
  position: absolute;
  width: max-content;
  font-weight: ${(props) => (props.center ? "400" : "500")};
  font-size: ${(props) => (props.center ? "20px" : "12px")};
  top: ${(props) => (props.center ? "20px;" : "-12px")};
`;

export const StopAverageStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  div {
    position: absolute;
    top: 40px;
  }
`;

export const VehicleLabelStyled = styled.div<{ isFocused: boolean }>`
  background: ${(props) =>
    props.isFocused ? "rgba(37, 63, 115, 1)" : "rgba(37, 63, 115, 0.85)"};
  color: white;
  padding: ${(props) => (props.isFocused ? "6px 10px" : "4px 8px")};
  border-radius: 4px;
  font-size: ${(props) => (props.isFocused ? "13px" : "12px")};
  font-weight: ${(props) => (props.isFocused ? "600" : "500")};
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  animation: fadeIn 0.2s ease;
  border: ${(props) =>
    props.isFocused ? "1px solid rgba(255, 255, 255, 0.3)" : "none"};
  font-family: "Readex Pro", sans-serif;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
